import React from 'react';
import { Link } from 'react-router-dom';

const PageNotFound = () => {
    return (
        <div className="container-fluid center text-center">
            <h1 className="display-1 font-weight-bold">404</h1>
            <p className="h1">Página não encontrada.</p>
            <Link to="/" className="btn btn-primary">
                Retornar à página inicial
            </Link>
        </div>
    );
};

export default PageNotFound;
